import { render, staticRenderFns } from "./BooterTon.vue?vue&type=template&id=02de90ee"
var script = {}
import style0 from "./BooterTon.vue?vue&type=style&index=0&id=02de90ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports